import React from 'react';

const resume = () => {
    return (
        <section id="resume">
            {/* Work
 ----------------------------------------------- */}
            <div className="row work" style={{fontSize: 16}}>
                <div className="three columns header-col">
                    <h1><span>Experience</span></h1>
                </div>
                <div className="nine columns main-col">
                    <div className="row item">
                        <div className="twelve columns">
                            <h3>Emigh Livestock; CA</h3>
                            <p className="info">Front End Software Engineer <span>•</span> <em className="date">2018 - Present</em></p>
                            <ul>
                                <li>•Prototyped and implemented UI’s using SDLC and agile methodologies using React/Redux/Thunks</li>
                                <li>•Assisted in reshaping critical business operations and reporting during product development and implementation</li>
                            </ul>
                        </div>
                    </div> {/* item end */}
                    <div className="row item">
                        <div className="twelve columns">
                            <h3>StartCHURCH; GA</h3>
                            <p className="info">Lead Full Stack Software Engineer<span>•</span> <em className="date">2012 - Present</em></p>
                            <ul>
                                <li>•Built a payment processing API that has successfully processed $15m+ transactions using PHP, Symfony 3, MySQL and Angular</li>
                                <li>•Created a React <a href="#portfolio">tax liability calculator</a> using rapid application development techniques</li>
                                <li>•Introduced best practices and coding standards when migrating two major legacy systems to a new common platform</li>
                                <li>•Architected and built a scalable cart checkout system using React/Redux</li>
                                <li>•Optimized MySQL data migration scripts to utilize a Message Queueing Server (RabbitMQ)</li>
                            </ul>
                        </div>
                    </div> {/* item end */}
                    <div className="row item">
                        <div className="twelve columns">
                            <h3>Chick-Fil-A; GA</h3>
                            <p className="info">General Manager<span>•</span> <em className="date">2009 - 2012</em></p>
                            <ul>
                                <li>•Oversaw profit & loss, inventory and labor for entire restaurant</li>
                                <li>•Managed morning shift crew of 15+ people</li>
                            </ul>
                        </div>
                    </div> {/* item end */}
                </div> {/* main-col end */}
            </div> {/* End Work */}
            {/* Skills
 ----------------------------------------------- */}
            <div className="row skill">
                <div className="three columns header-col">
                    <h1><span>Skills</span></h1>
                </div>
                <div className="nine columns main-col">
                    <p><strong>PHP, React, Redux, Webpack, MySQL, Symfony, PHP Unit, Redis, RabbitMQ, Doctrine ORM, Ansible, Vagrant, Authnet API, MailChimp API, HTML5, CSS3, Sass</strong></p>
                    <div className="bars">
                        <ul className="skills">
                            <li><span className="bar-expand debugging" /><em>General Debugging</em></li>
                            <li><span className="bar-expand php" /><em>PHP</em></li>
                            <li><span className="bar-expand react" /><em>React/Redux</em></li>
                            <li><span className="bar-expand mysql" /><em>MySQL</em></li>
                            <li><span className="bar-expand symfony" /><em>Symfony</em></li>
                            <li><span className="bar-expand webpack" /><em>Webpack/Gulp</em></li>
                            <li><span className="bar-expand git" /><em>Git</em></li>
                            <li><span className="bar-expand ansible" /><em>Ansible</em></li>
                        </ul>
                    </div>{/* end skill-bars */}
                </div> {/* main-col end */}
            </div> {/* End skills */}
        </section>
    )
}

export default resume


// WEBPACK FOOTER //
// ./src/main/resume.js